<template>
  <div id="personalareausers" class="personalareausers">
    <el-card class="box-card">
      <div>
        <el-row style="height:100%">
          <el-col :span="10" style="height:100%;">
            <div style="padding:5px;">
              <el-input placeholder="Поиск..." v-model="search" @change="changeSearchValue">
              </el-input>
            </div>
            <div style="height:100%;padding:5px;">
              <el-table
                ref="usersData"
                :data="users"
                highlight-current-row
                v-bind:height="resultsTableHeight"
                show-summary
                :summary-method="getSummaries"
                @current-change="handleUserSelect"
                style="width: 100%; height: 100%;" header-cell-class-name="default-header-color">
                <el-table-column
                  property="lastName"
                  label="Фамилия"
                  sortable
                  width="200"
                  class="grid-text-overflow"
                  >
                  <template slot-scope="scope">
                     <el-tooltip class="item" effect="dark" :content="scope.row.lastName" placement="top">
                       <span class="grid-text-overflow">{{ scope.row.lastName }}</span>
                     </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column
                  property="firstName"
                  label="Имя"
                  sortable
                  width="150"
                  class="grid-text-overflow"
                  >
                  <template slot-scope="scope">
                     <el-tooltip class="item" effect="dark" :content="scope.row.firstName" placement="top">
                       <span class="grid-text-overflow">{{ scope.row.firstName }}</span>
                     </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column
                  property="middleName"
                  label="Отчество"
                  sortable
                  class="grid-text-overflow"
                  >
                  <template slot-scope="scope">
                     <el-tooltip class="item" effect="dark" :content="scope.row.middleName" placement="top">
                       <span class="grid-text-overflow">{{ scope.row.middleName }}</span>
                     </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-col>
          <el-col :span="14" style="height:100%;border-left: 1px solid #d1dbe5;">
            <div style="width: 100%; height:41px; padding:5px;  margin-top: 5px; text-align: center;">
              <span style="font-weight:bold;"> {{ user ? user.fullName : '' }} </span>
            </div>
            <div style="padding:5px;">
              <el-tabs type="border-card" :style="userTabStyle" @tab-click="tabChange">
                <el-tab-pane>
                  <span slot="label"><i class="el-icon-edit" style="padding-right:5px"></i>Результаты</span>
                    <div style="height:100%;">
                      <el-row :gutter="10">
                        <el-table
                          :data="scenaries"
                          highlight-current-row
                          v-bind:height="resultsTableWithHeaderHeight"
                          @current-change="handleScenarioSelect"
                          style="width: 100%; height: 100%;"
                          :row-class-name="getScenarioRowStyle"
                          :key="scenarioKey" header-cell-class-name="default-header-color"
                          >
                          <el-table-column
                            property="label"
                            label="Сценарий"
                            sortable
                            class="grid-text-overflow"
                            >
                            <template slot-scope="scope">
                               <el-tooltip class="item" effect="dark" :content="scope.row.label" placement="top">
                                 <span class="grid-text-overflow">{{ scope.row.label }}</span>
                               </el-tooltip>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="Начат"
                            property="dateStarted"
                            sortable
                            class="grid-text-overflow"
                            width="170">
                            <template slot-scope="scope">
                              <el-icon name="time"></el-icon>
                              <el-tooltip class="item" effect="dark" :content="formatDate(scope.row.dateStarted)" placement="top">
                                <span class="grid-text-overflow" style="margin-left:10px;">{{ formatDate(scope.row.dateStarted) }}</span>
                              </el-tooltip>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="Закончен"
                            property="dateFinished"
                            sortable
                            class="grid-text-overflow"
                            width="170">
                            <template slot-scope="scope">
                              <el-icon name="time"></el-icon>
                              <el-tooltip class="item" effect="dark" :content="formatDate(scope.row.dateFinished)" placement="top">
                                <span class="grid-text-overflow" style="margin-left:10px;">{{ formatDate(scope.row.dateFinished) }}</span>
                              </el-tooltip>
                            </template>
                          </el-table-column>
                          <el-table-column
                            property="statusName"
                            label="Статус"
                            sortable
                            class="grid-text-overflow"
                            width="120">
                            <template slot-scope="scope">
                               <el-tooltip class="item" effect="dark" :content="scope.row.statusName" placement="top">
                                 <span class="grid-text-overflow">{{ scope.row.statusName }}</span>
                               </el-tooltip>
                            </template>
                          </el-table-column>
                        </el-table>
                      </el-row>
                      <el-dialog title="Результат сценария" :visible.sync="showResult" style="margin-top:-100px;">
                        <div style="height:100%;padding:5px;">
                          <el-row style="text-align:center">
                            <img src="../../assets/logo-transparent.png" style="height: 150px; width: auto; object-fit: contain; float:both;">
                          </el-row>
                          <el-row style="text-align:center;padding: 10px 0px 10px 10px;">
                            <b>
                              Результаты тестирования
                            </b>
                          </el-row>
                          <el-row :gutter="10">
                            <el-col :span="12" style="text-align:right;">
                              <el-row>
                                  Испытуемый:
                              </el-row>
                              <el-row>
                                  Сценарий:
                              </el-row>
                              <el-row>
                                  Закончен:
                              </el-row>
                              <el-row>
                                  Затрачено времени:
                              </el-row>
                            </el-col>
                            <el-col :span="12" style="text-align:left;">
                              <el-row>
                                  <b>{{ userName }}</b>
                              </el-row>
                              <el-row>
                                  <el-tooltip class="item" effect="dark" :content="scenarioLabel" placement="top">
                                    <b style="white-space: nowrap">{{ scenarioLabel }}</b>
                                  </el-tooltip>
                              </el-row>
                              <el-row>
                                  <b>{{ finishDate }}</b>
                              </el-row>
                              <el-row>
                                  <b>{{ timeElapsed }}</b>
                              </el-row>
                            </el-col>
                          </el-row>
                          <el-row style="text-align:center;padding: 10px 0px 10px 10px;">
                            <b>
                              Сводная информация по тестам
                            </b>
                          </el-row>
                          <el-row :gutter="10" style="padding: 0px 5px 0px 5px;">
                            <el-table
                              :data="tests"
                              border
                              show-summary
                              :summary-method="getScenarioSummaries"
                              v-bind:height="testsTableHeight"
                              style="width: 100%" header-cell-class-name="default-header-color">
                              <el-table-column
                                prop="label"
                                label="Тест"
                                class="grid-text-overflow"
                                >
                                <template slot-scope="scope">
                                   <el-tooltip class="item" effect="dark" :content="scope.row.label" placement="top">
                                     <span class="grid-text-overflow">{{ scope.row.label }}</span>
                                   </el-tooltip>
                                </template>
                              </el-table-column>
                              <el-table-column
                                prop="correct"
                                label="Верно"
                                width="80">
                              </el-table-column>
                              <el-table-column
                                prop="wrong"
                                label="Не верно"
                                width="102">
                              </el-table-column>
                              <el-table-column
                                prop="skipped"
                                label="Пропуск"
                                width="97">
                              </el-table-column>
                              <el-table-column
                                prop="total"
                                label="Всего"
                                width="80">
                              </el-table-column>
                              <el-table-column
                                prop="percentage"
                                label="Процент"
                                width="102">
                              </el-table-column>
                            </el-table>
                          </el-row>
                        </div>
                        <span slot="footer" class="dialog-footer">
                          <el-button type="primary" @click="closeResult">OK</el-button>
                        </span>
                      </el-dialog>
                  </div>
                </el-tab-pane>
                <el-tab-pane>
                  <span slot="label"><i class="el-icon-document" style="padding-right:5px"></i>Документы</span>
                  <div style="height:100%">
                    <el-row :gutter="10">
                      <el-table
                        :data="attachments"
                        style="width: 100%; height: 100%"
                        highlight-current-row
                        :height="resultsTableWithHeaderHeight"
                        :key="documentsKey" header-cell-class-name="default-header-color">
                        <el-table-column
                          property="label"
                          label="Тип"
                          class="grid-text-overflow"
                          >
                          <template slot-scope="scope">
                             <el-tooltip class="item" effect="dark" :content="scope.row.label" placement="top">
                               <span class="grid-text-overflow">{{ scope.row.label }}</span>
                             </el-tooltip>
                          </template>
                        </el-table-column>
                        <el-table-column
                          label="Дата загрузки"
                          property="uploaded"
                          width="180"
                          class="grid-text-overflow">
                          <template slot-scope="scope">
                            <el-icon name="time"></el-icon>
                            <el-tooltip class="item" effect="dark" :content="formatDate(scope.row.uploaded)" placement="top">
                              <span style="margin-left: 10px" class="grid-text-overflow">{{ formatDate(scope.row.uploaded) }}</span>
                            </el-tooltip>
                          </template>
                        </el-table-column>
                        <el-table-column
                          label="Операции"
                          width="120"
                          class="grid-text-overflow">
                          <template slot-scope="scope">
                            <el-button
                              size="mini"
                              icon="el-icon-upload2"
                              @click="downloadAttachment(scope.$index, scope.row)">Скачать</el-button>
                          </template>
                        </el-table-column>
                      </el-table>
                    </el-row>
                  </div>
                </el-tab-pane>
                <el-tab-pane style="height:100%;">
                  <span slot="label"><i class="el-icon-message" style="padding-right:5px"></i>Уведомления</span>
                  <el-input
                    type="textarea"
                    :rows="3"
                    placeholder="Введите сообщение..."
                    v-model="messageToSend"
                    style="width:100%;padding-bottom:5px;">
                  </el-input>
                  <div style="width:100%;text-align:center;">
                    <el-button type="primary" style="width: 150px;" @click="sendMessage" size="mini">Отправить</el-button>
                  </div>
                  <div class="notifications" :style="notificationAreaStyle">
                    <span v-if="messages && messages.length > 0">
                      <span v-for="message in messages">
                        <span :class="getMessageStyle(message)">
                          <div class="message">
                            <div class="message-header">
                              <div style="width:100%">
                                {{ formatDateWithHoursAndMinutes(message.created) }}
                                <el-checkbox v-model="message.isRead" style="float:right" disabled><span style="color:#fff;font-size:1rem;">Прочитано</span></el-checkbox>
                              </div>
                            </div>
                            <div class="message-body">
                              {{ message.text }}
                            </div>
                          </div>
                        </span>
                      </span>
                    </span>
                    <span v-else class="middle-aligned information">
                      <div>Нет ни одного уведомления</div>
                    </span>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-card>
  </div>
</template>

<script>
  import config from '../../appsettings.js'
  import layout from '../../api/helpers/layout'
  import grid from '../../api/helpers/grid'
  import contest from '../../api/contest/time'
  import states from '../../api/contest/contest-states'

  export default {
    name: 'personalareausers',
    data() {
      return {
        loading: false,
        users: [],
        user: null,
        scenaries: [],
        scenarioCurrentRow: null,
        scenario: null,
        attachments: [],
        messages: [],
        resultsHeight: null,
        showResult: false,
        search: '',
        messageToSend: '',
        counter: 0
      }
    },
    computed: {
      resultsTableHeight: function () {
        if(!this.resultsHeight) {
          let height = layout.getParentClientHeight();
          if(height)
            return height - 77;
        }
        return this.resultsHeight - 47;
      },
      resultsTableWithHeaderHeight: function() {
        if(!this.resultsHeight) {
          let height = layout.getParentClientHeight();
          if(height)
            return height - 145;
        }
        return this.resultsHeight - 115;
      },
      testsTableHeight: function() {
        let height = this.resultsTableHeight;
        if(height)
          return 250;
        return null;
      },
      userTabStyle: function() {
        let height = layout.getParentClientHeight();
        if(height)
          return 'height:'+(height - 78)+'px;';
        return 'height:100px;';
      },
      notificationAreaStyle: function() {
        let height = layout.getParentClientHeight();
        if(height)
          return 'height:'+(height - 275)+'px; padding-top:5px;';
        return 'height:100px;  padding-top:5px;';
      },
      scenarioKey: function() {
        return 'scenarioKey' + this.counter;
      },
      documentsKey: function() {
        return 'documentsKey' + (this.counter + 1);
      },
      userName: function() {
        if(this.scenario)
          return this.scenario.fullName;
        return '';
      },
      scenarioLabel: function() {
        if(this.scenario)
          return this.scenario.label;
        return '';
      },
      scenarioResultTotal: function() {
        if(this.scenario)
          return this.scenario.total;
        return null;
      },
      finishDate: function() {
        if(this.scenario)
          return grid.formatDate(this.scenario.dateFinished);
        return '';
      },
      timeElapsed: function() {
        if(this.scenario)
          return contest.formatMinutes(this.scenario.timeElapsedInSeconds);
        return '';
      },
      tests: function() {
        if(this.scenario)
          return this.scenario.tests;
        return [];
      }
    },
    methods: {
      changeSearchValue(value) {
        this.fetchData(value)
      },
      fetchData(value) {
        this.loading = true;
        let self = this;
        let prefix = config.API_PREFIX;
        this.$gf.getOptions().then(options => {
          options.params = {
          };
          ///USERS
          let get = value ? `${prefix}candidates/search/?text=${value}` : `${prefix}candidates`;
          self.$http.get(get, options)
            .then(response => {
              self.users = response.data;
              self.loading = false;
              if(self.users && self.users.length)
                self.handleUserSelect(self.users[0]);
            })
            .catch(data => {
              self.$gf.checkError(data);
              self.loading = false;
            });
        }).catch(err => {
          this.$gf.catchOptions();
          this.loading = false;
        });
      },
      getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        sums[0] = 'Всего пользователей:';
        sums[1] = this.users ? this.users.length : 0;

        return sums;
      },
      getScenarioSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        let total = this.scenarioResultTotal;
        if(total) {
          sums[0] = total.label;
          sums[1] = total.correct;
          sums[2] = total.wrong;
          sums[3] = total.skipped;
          sums[4] = total.total;
          sums[5] = total.percentage;
        }

        return sums;
      },
      getMessageStyle(message) {
        let clazz = 'read';
        if(message && !message.isRead)
          clazz = 'unread';
        return clazz;
      },
      formatDateWithHoursAndMinutes(d) {
        if(d) {
          d = new Date(d);
          var dateFormat = require('dateformat');
          return dateFormat(d, 'dd.mm.yyyy HH:MM:ss');
        }
        return '';
      },
      resize() {
        let height = layout.getParentClientHeight();
        if(height)
          this.resultsHeight = height - 30;
        else
          this.resultsHeight = null;
      },
      closeResult() {
        this.showResult = false;
      },
      getScenarioRowStyle(row, rowIndex) {
        if(row) {
          let status = row.row.status;
          if(status) {
            //let color = states.getScenarioStatusColor(status);
            //return 'background-color:' + color;
            return states.getScenarioStatusClass(status);
          }
        }
        //return 'background-color:#cfd1d6';

        return 'scenario0';
      },
      getScenariesHeaderStyle(row, rowIndex) {
        return 'background-color:#324157;color:white;';
      },
      tabChange() {
        this.counter++;
      },
      sendMessage() {
        if(this.user && this.messageToSend) {
          let uid = this.user.id;
          if(uid) {
            this.loading = true;
            let self = this;
            let prefix = config.API_PREFIX;
            this.$gf.getOptions().then(options => {
              options.params = {
              };
              ///MESSAGES
              self.loading = true;
              self.$http.post(`${prefix}candidates/${uid}/messages`, { text: this.messageToSend }, options)
                .then(response => {
                  this.messageToSend = '';
                  self.$http.get(`${prefix}candidates/${uid}/messages`, options)
                    .then(response => {
                      self.messages = response.data;
                      self.loading = false;
                    })
                    .catch(data => {
                      self.$gf.checkError(data);
                      self.loading = false;
                    });
                })
                .catch(data => {
                  self.$gf.checkError(data);
                  self.loading = false;
                });
            }).catch(err => {
              this.$gf.catchOptions();
              this.loading = false;
            });
          }
        }
      },
      handleUserSelect(val) {
        this.user = val;
        this.messages = [];
        this.attachments = [];
        this.scenaries = [];
        if(this.user) {
          let uid = this.user.id;
          if(uid) {
            this.loading = true;
            let self = this;
            let prefix = config.API_PREFIX;
            this.$gf.getOptions().then(options => {
              options.params = {
              };
              ///USER
              self.$http.get(`${prefix}candidates/${uid}/results`, options)
                .then(response => {
                  self.scenaries = response.data;
                  self.loading = false;
                })
                .catch(data => {
                  self.$gf.checkError(data);
                  self.loading = false;
                });
              ///DOCUMENTS
              self.loading = true;
              self.$http.get(`${prefix}candidates/${uid}/attachments`, options)
                .then(response => {
                  self.attachments = response.data;
                  self.loading = false;
                })
                .catch(data => {
                  self.$gf.checkError(data);
                  self.loading = false;
                });
              ///MESSAGES
              self.loading = true;
              self.$http.get(`${prefix}candidates/${uid}/messages`, options)
                .then(response => {
                  self.messages = response.data;
                  self.loading = false;
                })
                .catch(data => {
                  self.$gf.checkError(data);
                  self.loading = false;
                });
            }).catch(err => {
              this.$gf.catchOptions();
              this.loading = false;
            });
          }
        }
      },
      handleScenarioSelect(val) {
       this.scenarioCurrentRow = val;
       if(this.user && this.scenarioCurrentRow) {
         let uuid = this.user.id;
         let suid = this.scenarioCurrentRow.uid;
         if(uuid && suid) {
           this.loading = true;
           let self = this;
           let prefix = config.API_PREFIX;
           this.$gf.getOptions().then(options => {
             options.params = {
             };
             ///TESTS
             self.$http.get(`${prefix}candidates/${uuid}/results/${suid}`, options)
               .then(response => {
                 self.scenario = response.data;
                 self.loading = false;
                 self.showResult = true;
               })
               .catch(data => {
                 self.$gf.checkError(data);
                 self.loading = false;
               });
           }).catch(err => {
             this.$gf.catchOptions();
             this.loading = false;
           });
        }
      }
    },
    downloadAttachment(index, row) {
      if(this.user) {
        let uuid = this.user.id;
        if(uuid) {
          let self = this;
          let prefix = config.API_PREFIX;
          this.$gf.getOptions().then(options => {
            options.params = { };
            self.$http.get(`${prefix}candidates/${uuid}/attachments/${row.uid}`, options)
              .then(response => {
                window.location.href = `${prefix}candidates/${uuid}/attachments/${row.uid}/${response.data}`;
              })
              .catch(data => self.$gf.checkError(data));
            }).catch(err => this.$gf.catchOptions());
        }
      }
    },
    formatDate(d) {
      return grid.formatDateWithHoursAndMinutes(d);
    }
    },
    beforeDestroy: function () {
      window.removeEventListener('resize', this.resize);
    },
    created: function () {
      window.addEventListener('resize', this.resize);
      this.fetchData(null);
    }
  }
</script>

<style scoped>
  .personalareausers {
    height: calc(100% - 20px);
    background: #eef1f6;
    border: 1px solid #d1dbe5;
  }
  .notifications {
    /*height: 100%;
    background: #eef1f6;
    border: 1px solid #d1dbe5;
    border-radius: 4px !important;*/
    overflow-y: scroll;
  }
  .middle-aligned {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .information {
    width: 100%;
    height: 100%;
    text-align: center;
  }
  .grid-text-overflow {
    /*overflow:hidden;
    display:inline-block;*/
    /*margin-left: 10px -- it s for items with icons*/
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>
<style>
  .el-card__header {
    padding: 4px 5px !important;
  }
  .el-card__body {
    padding: 0px !important;
  }
  .unread .message-header {
    background-color: #375b81 !important;
  }
  .read .message-header {
    /*background-color: #597da3 !important;*/
    background-color: #7b9fc5 !important;
  }
  .message-body {
    text-align: justify;
    text-justify: inter-word;
  }
  .el-table .scenario0 {
    background: #cfd1d6;
  }
  .el-table .scenario1 {
    background: #b3d8ff;
  }
  .el-table .scenario2 {
    background: #c2e7b0;
  }
  .el-table .scenario3 {
    background: #f7d89b;
  }
  .el-table .scenario4 {
    background: #fdbbbb;
  }
</style>



// WEBPACK FOOTER //
// src/components/operational/personalareausers.vue